import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';

@Component({
  selector: 'app-help-location',
  templateUrl: './help-location.component.html'
})
export class HelpLocationComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService) {

  }

  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();

    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelpLocationLabels();
  }
  cap_header;
  cap_desc;
  gethelpLocationLabels() {

    this.graphQlService.gethelpLocationLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.cap_header = labels.filter(x => x.key == "location_heading").map(y => y.value);
        this.cap_desc = labels.filter(x => x.key == "location_desc").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }

}
